// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileMenuHead_root__CQTaI","login":"MobileMenuHead_login__ov2rn","register":"MobileMenuHead_register__YCivh"};